import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Component({
	selector: 'app-chips',
	templateUrl: './chips.component.html',
	styleUrls: ['./chips.component.scss']
})
export class ChipsComponent implements OnInit {

	@Input() type: 'standard' | 'classic' | 'prime' | 'legend' | 'count' | 'progressive' | 'grand' | 'capsule' | 'royal-capsule' = 'standard';
	@Input() data: any;
	@Input() classes: any;

	@Input() removable: boolean = false;
	@Input() changeFilter: boolean = true;
	@Input() background: string = 'var(--secondary-four)';
	@Input() color: string = 'var(--primary-one)';

	@Output() title = new EventEmitter<boolean>();
	@Output() users = new EventEmitter<boolean>();
	@Output() removed = new EventEmitter();
	@Output() chipInfo = new EventEmitter<boolean>();
	@Output() shortInfo = new EventEmitter<boolean>();
	@Output() action = new EventEmitter();

	disableRipple = true;
	skillLevelData;
	toolTip = '';

	constructor(
		public gfService: GlobalFunctionService
	) { }

	ngOnChanges(changes): void {
		// if (changes.type) this.background = this.type === 'legend' ? 'white' : 'var(--secondary-four)';
	}

	ngOnInit(): void {
		if (this.type === 'legend') {
			this.background = 'white';
		} else if (this.type === 'progressive' && this.data && this.data.toolTip) {
			const currentUser = this.gfService.sessionUser;
			if (currentUser.weightageData) {
				this.skillLevelData = currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
				let value = this.data.progress;
				if (value) {
					value = value.split('%');
					let finalValue;
					if (value && value.length) {
						let sliderValue = Number(value[0]);
						sliderValue = this.processData('general', sliderValue);
						if (!sliderValue) {
							sliderValue = 0;
						}
						finalValue = sliderValue;
						if (this.skillLevelData[finalValue]) {
							this.toolTip = this.skillLevelData[finalValue].value;
						}
					}
				}
			}
		}
	}


	processData(type: 'general' | 'expected' = 'general', sliderValue) {
		if (Array.isArray(this.skillLevelData) && this.skillLevelData.length) {
			const weightageData: any = this.skillLevelData.filter(items => items.key !== null);
			const individualPercentage = 100 / weightageData.length;
			weightageData.map((resp, index) => {
				resp.percentage = individualPercentage * (index + 1);
			});
			var closest = this.closestValue(weightageData, sliderValue);
			if (closest) {
				weightageData.map((data, index) => {
					if (data.percentage === closest) {
						sliderValue = index;
					}
				});
				if (!([null, undefined].includes(this.skillLevelData[sliderValue].weightage))) {
					sliderValue = this.skillLevelData[sliderValue].weightage;
				}
			} else {
				sliderValue = 0;
			}
		}
		let returnData = sliderValue - 1;
		if (returnData < 0) {
			returnData = 0;
		}
		return returnData;
	}

	closestValue(data, value) {
		return data.reduce(function (prev, curr) {
			let prevValue = prev;
			let currentValue = curr;
			if (prevValue.hasOwnProperty('percentage')) {
				prevValue = prevValue.percentage;
			}
			if (currentValue.hasOwnProperty('percentage')) {
				currentValue = currentValue.percentage;
			}
			return (Math.abs(currentValue - value) < Math.abs(prevValue - value) ? currentValue : prevValue);
		});
	}

	titleInfo() {
		if (this.type === 'royal-capsule' && !this.changeFilter) {
			return false;
		}
		this.title.emit(true);
	}

	usersInfo() {
		this.users.emit(true);
	}

	remove(el) {
		this.removed.emit(el);
	}

	chip() {
		this.chipInfo.emit(true);
	}

	shortInformation() {
		this.shortInfo.emit(true);
	}

	iconAction(data, actionEl) {
		this.action.emit({ data, actionEl });
	}
}
